import { render, staticRenderFns } from "./CustomerArea.vue?vue&type=template&id=51f5aba1"
import script from "./CustomerArea.vue?vue&type=script&lang=js"
export * from "./CustomerArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f5aba1')) {
      api.createRecord('51f5aba1', component.options)
    } else {
      api.reload('51f5aba1', component.options)
    }
    module.hot.accept("./CustomerArea.vue?vue&type=template&id=51f5aba1", function () {
      api.rerender('51f5aba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/CustomerArea.vue"
export default component.exports